import React, { useState, useEffect,useContext} from 'react';
import { useNavigate,useParams} from 'react-router-dom';
import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import { jwtDecode } from 'jwt-decode';
import SelectBox4 from '../../../Components/Select4';
import axios from 'axios';
import { toast } from 'react-toastify';

import '../../../Assets/css/toast.css';
import { GlobalContext } from '../../../GlobalContext';


const EditProduct = () => {

    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('Edit Products Information');
    });
    const { productId } = useParams();

    const token = localStorage.getItem('token');
    const decodedToken = jwtDecode(token);
    const userId ={userID: decodedToken.id};

    //---------create Recharge modal-----------
    const [brand_name, setBrandName] = useState('');
    const [brandOpen, setBrandOpen] = useState(false);
    const [category_name, setCategoryName] = useState('');
    const [categoryOpen, setCategoryOpen] = useState(false);

    const [productData, setProductData] = useState({name:'', price: 0, stock: 0, seller: '', category: '', brand : ''});

    const handleProductChange = (e) => {
        setProductData({
            ...productData,
            [e.target.name]: e.target.value,
        });
    };

    const handleDataFromChild = (data) => {
        setProductData({
            ...productData,
            ['brand']: data,
        });
    };
    const handleDataFromChild1 = (data) => {
        setProductData({
            ...productData,
            ['category']: data,
        });
    };
    
    const [brandList, setBrandList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const fetchProduct = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const response = await axios.post(`${POCBaseUrl}/products/getone`,{productId},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                setProductData(response.data.data);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }
    }
    const fetchBrand = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const response = await axios.post(`${POCBaseUrl}/products/get/brand`,
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                const brandNames = response.data.data.map(brand => brand.brand_name);
                brandNames.unshift('Select Brand');
                setBrandList(brandNames);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }
    }

    const fetchCategory = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const response = await axios.post(`${POCBaseUrl}/products/get/category`,
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                const categoryNames = response.data.data.map(category => category.category_name);
                categoryNames.unshift('Select Category');
                setCategoryList(categoryNames);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }
    }
    
    useEffect(()=> {
        fetchProduct();
        fetchBrand();
        fetchCategory();
    },[])

    const handleBrandCreate = async(e) => {
        e.preventDefault();
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if (brand_name !== '') {
            } else {
              toast.warn("Please input a Brand name", {
                  className: 'centered-toast0',
                  bodyClassName: 'centered-body',
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeButton: false,
                  pauseOnHover: false,
                  draggable: true,
                });
              return;
            }
            const brandData = {'brand_name': brand_name};
            const response = await axios.post(`${POCBaseUrl}/products/brand`, {brandData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                toast.success('Brand name added successfully!', {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    // draggable: true,
                    pauseOnFocusLoss: true
                  });
                setBrandOpen(false);
                fetchBrand();
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    const handleCategoryCreate = async(e) => {
        e.preventDefault();

        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if (category_name !== '') {
            } else {
              toast.warn("Please input a Category name", {
                  className: 'centered-toast0',
                  bodyClassName: 'centered-body',
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeButton: false,
                  pauseOnHover: false,
                  draggable: true,
                });
              return;
            }
            const categoryData = {'category_name':category_name};
            const response = await axios.post(`${POCBaseUrl}/products/category`, {categoryData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                toast.success('Category added successfully!', {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    // draggable: true,
                    pauseOnFocusLoss: true
                  });
                  setCategoryOpen(false);
                  fetchCategory();
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };
    const handleProductEdit = async(e) => {
        e.preventDefault();
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;
            // console.log('productdata',productData);
            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if (productData.name !== '') {
              } else {
                toast.warn("Please input a name", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }
            if (productData.price !== 0 && productData.price !== '') {
              } else {
                toast.warn("Please input a Price", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }
            if (productData.stock !== 0 && productData.stock !== '') {
              } else {
                toast.warn("Please input a Stock", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }
            if (productData.seller !== '') {
            } else {
                toast.warn("Please input a Seller", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                    });
                return;
            }
            if (productData.category !== '') {
                } else {
                toast.warn("Please Select a category", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                    });
                return;
            }
            if (productData.brand !== '') {
                } else {
                toast.warn("Please Select a Brand", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                    });
                return;
            }
            const response = await axios.post(`${POCBaseUrl}/products/editproduct`, {productId,productData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                toast.success('Product updated successfully!', {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    // draggable: true,
                    pauseOnFocusLoss: true
                  });
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    const gotoProductList = () => {
        navigate(`/manageproduct`); // Use navigate for routing
    };

    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px] list-table-scroll">
                <div className="ml-[25px] mt-2.5 pr-[40px] border-r border-white">
                    <div className='mb-[22px] flex'>
                        <Label text={'Name'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField name = {'name'} value={productData.name || ''} onChange={handleProductChange} placeholder={'Name'} className={'!text-[#5a5655]'}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Price(€)'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField name = {'price'} type={'number'} value={productData.price || ''} onChange={handleProductChange} placeholder={'Price'} className={'!text-[#5a5655]'}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Stock'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField name = {'stock'} type={'number'} value={productData.stock || ''} onChange={handleProductChange} placeholder={'Stock'} className={'!text-[#5a5655]'}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Seller'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField name = {'seller'} value={productData.seller || ''} onChange={handleProductChange} placeholder={'Seller'} className={'!text-[#5a5655]'}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Category'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <SelectBox4 name={'category'} value={productData.category || ''} onSendData={handleDataFromChild1} options={categoryList} placeholder={'Please Select Category'} selectwidth={272}/>
                        </div>
                        <div>
                            <Button children={'Add'} onClick={()=> setCategoryOpen(true)}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Brand'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <SelectBox4 name={'brand'} value={productData.brand || ''} onSendData={handleDataFromChild} options={brandList} placeholder={'Please Select Brand'} selectwidth={272}/>
                        </div>
                        <div>
                            <Button children={'Add'} onClick={()=> setBrandOpen(true)}/>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-2.5 bg-[#f0f0f0] flex'>
                <button onClick={handleProductEdit} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2 px-24 rounded text-white cursor-pointer'>
                    Update 
                </button>
                <button onClick={gotoProductList} className='inline-block mt-2.5 mb-2.5 ml-4 bg-[#2776c3] py-2 px-24 rounded text-white cursor-pointer'>
                    retun to the list
                </button>
            </div>
            {categoryOpen && 
                (<div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
                    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-4 relative">

                        <div className="flex justify-center text-[#5a5655] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                            Create Category
                        </div>
                        <div className='flex justify-center mt-5 mb-5'>
                            <InputField name = {'category_name'} value={category_name || ''} onChange={(e)=>setCategoryName(e.target.value)} type={'text'} placeholder={'Please enter Category'} />
                        </div>
        
                        <div className="border-t border-gray-300 pt-1 flex justify-around gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <div
                                className="px-4 py-1 rounded-lg text-[#5a5655] text-sm border-none outline-none tracking-wide active:bg-gray-200 cursor-pointer"
                                onClick={()=> setCategoryOpen(false)} // Close modal on click
                            >
                                No
                            </div>
                            <div
                                onClick={handleCategoryCreate}
                                className="px-4 py-1 rounded-lg text-blue-500 text-sm border-none outline-none tracking-wide active:bg-blue-600 cursor-pointer"
                            >
                                Add
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {brandOpen && 
                (<div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]">
                    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-4 relative">

                        <div className="flex justify-center text-[#5a5655] text-[14px]" style={{ fontFamily: 'Liberation Serif' }}>
                            Create Brand Name
                        </div>
                        <div className='flex justify-center mt-5 mb-5'>
                            <InputField name = {'brand_name'} value={brand_name || ''} onChange={(e)=>setBrandName(e.target.value)} type={'text'} placeholder={'Please enter Category'} />
                        </div>
        
                        <div className="border-t border-gray-300 pt-1 flex justify-around gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <div
                                className="px-4 py-1 rounded-lg text-[#5a5655] text-sm border-none outline-none tracking-wide active:bg-gray-200 cursor-pointer"
                                onClick={()=> setBrandOpen(false)} // Close modal on click
                            >
                                No
                            </div>
                            <div
                                onClick={handleBrandCreate}
                                className="px-4 py-1 rounded-lg text-blue-500 text-sm border-none outline-none tracking-wide active:bg-blue-600 cursor-pointer"
                            >
                                Add
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default EditProduct;